import React, { useState } from 'react';
import {
	Checkbox,
	FormGroup,
	FormControlLabel,
	Grid,
} from '@mui/material';
import { cloneDeep } from 'lodash';
import { makeStyles } from '@mui/styles';

const DONOR_DEFAULTS = [31, 33, 34, 36];

export default function TriggerOptions({ form, options, donorDefault }) {
	const [ all, setAll ] = useState(false);
	const { values, setFieldValue } = form;

	const handleChange = (trigger, e) => {
		console.log(trigger.id);
		let newRuleTriggerOptions = cloneDeep(values.ruleTriggerOptions);
		if (e.target.checked) {
			newRuleTriggerOptions.push(trigger.id);
		} else {
			newRuleTriggerOptions = newRuleTriggerOptions.filter(option => option !== trigger.id);
		}
		setAll((newRuleTriggerOptions.length === options.length));
		setFieldValue('ruleTriggerOptions', newRuleTriggerOptions);
	};

	const handleCheckAll = (e) => {
		const empty = donorDefault && (form.values.ruleTrigger===3)
			? options.filter(option => DONOR_DEFAULTS.indexOf(option.id) > -1).map(option => option.id)
			: [];
		const newRuleTriggerOptions = (e.target.checked) ? options.map(option => option.id) : empty;
		setAll(e.target.checked);
		setFieldValue('ruleTriggerOptions', newRuleTriggerOptions);
	};

	const isChecked = (id) => {
		return (values.ruleTriggerOptions.indexOf(id) > -1);
	};

	return (
		<Grid container className="triggers" direction="row" justify="center" alignItems="center">
			{ options.length === 0 && (<Grid items xs={12}>
				There are no options available for selected trigger.
			</Grid>)}
			{ options.length > 0 && (
				<Grid item xs={12}>
					<p>Trigger status options:</p>
					<FormControlLabel
						control={<Checkbox checked={all} onChange={handleCheckAll} name="checkedB" color="primary" />}
						label="Select All"
						labelPlacement="start"
					/>
				</Grid>
			)}
			{ options.length > 0 && (
			<Grid item xs={12}>
					{options.map((trigger) => {
						return (
							<FormControlLabel
								control={<Checkbox
									disabled={DONOR_DEFAULTS.indexOf(trigger.id) > -1 && donorDefault}
									checked={(isChecked(trigger.id))}
									onChange={(e) => handleChange(trigger, e)}
									name="checkedB"
									color="primary"
								/>}
								label={trigger.name}
								labelPlacement="start"
							/>
						);
					})}
			</Grid>
			)}
		</Grid>
	);
}
